import { motion } from 'framer-motion'
import useAnimation from '../../utils/hooks/useAnimation'
import { Link } from '../../components'
import styles from './PageHeader.module.scss'

const PageHeader = ({buttonText, buttonHref, buttonIcon, heading, ...linkProps}) => {
  const [animate, trigger] = useAnimation({ y: -2 })

  return (
    <header className={styles.header}>
      <Link
        variant="secondary"
        to={buttonHref}
        size="small"
        onMouseEnter={trigger}
        {...linkProps}
      >
        {buttonText}
        {buttonIcon && 
        <motion.span animate={animate}>
          {buttonIcon}
        </motion.span>
        }
      </Link>
      {heading &&
      <h1>{heading}</h1>
      }
    </header>
  )
}

export default PageHeader
